import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import Course, { CourseProps } from './Course'; // Import the Course component
import useAuth from '../../hooks/useAuth';
import { fetchAllCourses } from '../../api'; // Import the fetchAllCourses function
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/index';
import { setCourses } from '../../redux/slices/courseSlice';
import { useLocation } from 'react-router-dom';
import ErrorDisplay from './Error';
import LoadingDisplay from './Loading';
import paths from '../../constants/paths';
import NotFoundPage from '../Error/NotFoundPage';
import { Exam } from '../Exams/type';
import useResponsive from '../../hooks/useResponsive';
// import Slider from '@ant-design/react-slick';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';

interface SubcriptionsPageProps {
  filter?: string;
}

const SubcriptionsPage: React.FC<SubcriptionsPageProps> = ({
  filter = 'all',
}) => {
  const location = useLocation();
  const { user } = useAuth();
  const dispatch = useDispatch();
  // const courses = useSelector((state: RootState) => state.course.courses);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [filteredCourses, setFilteredCourses] = useState<CourseProps[]>([]); // Add filteredCourses state
  // const [exams, setExams] = useState<Exam[]>([]);
  const isMobile = useResponsive('down', 'md');

  const isTeacher =
    (location.pathname === paths.MYCOURSE ||
      location.pathname === paths.MYINFO) &&
    !!user &&
    (user.role === 'admin' || user.role === 'teacher');

  // Check if path is /mycourse then filter courses by user id
  useEffect(() => {
    setLoading(true);

    setTimeout(() => {
      setLoading(false); // Set loading to false after the delay
    }, 500); // Ensure loading lasts for at least 0.5 seconds
  }, []);

  useEffect(() => {
    // Filter results by filter props (all, Math, Physic)
    if (filter && user?.buyCourses) {
      setFilteredCourses(
        user?.buyCourses?.filter(
          (course) => course.subject === filter || filter === 'all'
        )
      );
    }
  }, [filter, user?.buyCourses]);

  // useEffect(() => {
  //   //setLoading(true);
  //   const loadCourses = async () => {
  //     try {
  //       const data = await fetchAllCourses();
  //       dispatch(setCourses(data)); // Dispatch setCourses action

  //     } catch (err) {
  //       console.error('Error fetching courses:', err);
  //       setError('Failed to load courses');
  //     } finally {
  //       //setLoading(false);
  //     }
  //   };

  //   loadCourses();
  // }, [dispatch]);

  // if (location.pathname !== paths.HOME && !user) {
  //   return <NotFoundPage message="Trang chỉ dành cho tài khoản đăng nhập" />;
  // }

  if (!user) {
    // return <NotFoundPage message="Trang chỉ dành cho tài khoản đăng nhập" />;
    return location.pathname !== paths.HOME ? (
      <NotFoundPage message="Trang chỉ dành cho tài khoản đăng nhập" />
    ) : (
      <></>
    );
  }

  return (
    <Box sx={{ px: isMobile ? 2 : 0 }}>
      <Box sx={{ position: 'relative', mb: 4, mt: 2 }}>
        {loading && (
          <LoadingDisplay loadingMessage="Đang tải chi tiết khóa học..." />
        )}

        {error && (
          <ErrorDisplay errorMessage="Đã xảy ra lỗi. Vui lòng thử lại sau." />
        )}

        {user?.buyCourses?.length === 0 ? (
          <>
            {location.pathname !== paths.HOME && (
              <Typography variant="h6" textAlign="center">
                Bạn chưa đăng ký khoá học nào
              </Typography>
            )}
          </>
        ) : (
          <Typography variant="h3" textAlign="center">
            Khoá đã đăng ký
          </Typography>
        )}
        {!loading && !error && (
          <>
            <Grid container spacing={3}>
              {filteredCourses.map((course) => (
                <Grid
                  item
                  xs={12} // Full width on extra small screens
                  sm={6} // Half width on small screens and above
                  md={4} // One-third width on medium screens and above (adjust as needed)
                  lg={4} // One-fourth width on large screens and above (adjust as needed)
                  xl={2}
                  key={course.courseId}
                >
                  <Course
                    courseId={course.courseId}
                    image={course.image}
                    title={course.title}
                    description={course.description}
                    favorites={course.favorites}
                    members={course.members}
                    exams={course.exams}
                    videos={course.videos}
                    pdfs={course.pdfs}
                    createdAt={course.createdAt}
                    lastUpdatedAt={course.lastUpdatedAt}
                    createdBy={course.createdBy}
                    price={course.price}
                    contactLink={course.contactLink}
                    isTeacher={isTeacher}
                    rates={course.rates}
                    items={course.items} // Add missing items property
                    learningObjectives={course.learningObjectives} // Add missing learningObjectives property
                    subject={course.subject} // Add missing subject property
                    isPrivate={course.isPrivate} // Add missing isPrivate property
                  />
                </Grid>
              ))}
            </Grid>
          </>
        )}
      </Box>
    </Box>
  );
};

export default SubcriptionsPage;
